import { render, staticRenderFns } from "./my-stores.vue?vue&type=template&id=1b980198&scoped=true"
import script from "./my-stores.vue?vue&type=script&lang=js"
export * from "./my-stores.vue?vue&type=script&lang=js"
import style0 from "./my-stores.vue?vue&type=style&index=0&id=1b980198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b980198",
  null
  
)

export default component.exports